import { drupal } from "@/lib/drupal/drupal"
import { DrupalBlockProductAnnouncement, DrupalTaxonomyTermProduct } from "@/types"
import { DrupalJsonApiParams } from "drupal-jsonapi-params"
import { Body } from "../wysiwyg/Body"
import { StatusMessage } from "../wysiwyg/StatusMessage"

export const ProductNotifications = async ({product, type}: {
  product: DrupalTaxonomyTermProduct,
  type?: "" | "draft" | "past" | "upcoming";
}) => {
  const params = new DrupalJsonApiParams();
  params.addCustomParam({
    'views-filter': {
      'field_products_target_id': product.drupal_internal__tid
    }
  })
  
  let viewName = 'block_content--anouncements';
  if (type) {
    viewName += `_${type.trim()}`;
  }

  const notifications = await drupal.getView(viewName, {
    params: params.getQueryObject() });
  
  return <div className="max-w-4xl">
    {notifications.results.map((block: DrupalBlockProductAnnouncement) => (
    <StatusMessage key={block.id} type={block.field_status} heading={block.field_title} dismissId={block.field_dismissible ? block.id : block.field_dismissible}>
      <Body value={block.body.processed} />
    </StatusMessage>))}
  </div>
}

function getCurrentTimeInUTC() {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * 60000; // Offset in milliseconds
  const localISOTime = new Date(now.getTime() - timezoneOffset).toISOString().slice(0, -5); // Remove milliseconds and Z
  return localISOTime;
}